import { SchemaDescription, ObjectSchema } from 'yup';
import { UseFormReturn } from 'react-hook-form';

export function useIsFieldRequired(form: UseFormReturn<any>, schema: ObjectSchema<any>) {
  return {
    isFieldRequired(fieldName: string): boolean {
      const { getValues } = form;
      const field = schema.describe({ value: getValues() }).fields[fieldName];
      if (!field) throw new Error(`Field '${fieldName}' not found in schema`);
      return (field as SchemaDescription).tests.some((test) => test.name === 'required');
    },
  };
}
